<template>
  <!-- 排行榜部分 -->
  <div class="topSrarch">
    <!-- 排行榜上半标题部分 -->
    <div class="topSrarch_top">
      <div class="topSrarch_top_content">
        <div class="topSrarch_top_text">全站排行榜</div>
        <div class="topSrarch_top_text">
          <span>排序：</span>
          <select id="sort" v-model="sortId">
            <option value="0">点赞榜</option>
            <option value="1">评论榜</option>
            <option value="2">打卡榜</option>
          </select>
        </div>
      </div>
    </div>
    <!-- 排行榜下半排行部分 -->
    <div class="topSrarch_bottom">
      <!-- 排行榜榜单部分 -->
      <div
        class="topSrarch_bottom_item_box"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="topSrarch_bottom_item">
          <div class="topSrarch_bottom_item_left">
            <div class="NO_style">{{ index + 1 }}</div>
            <div class="NO_name">{{ item.name }}</div>
            <div v-if="index + 1 <= 3" class="hot">热</div>
          </div>
          <div class="topSrarch_bottom_item_right">
            <div class="Number">{{ item.count }}</div>
            <div class="iconImg_box">
              <img v-if="sortId == 0" src="https://fview.5kjs.com/activity/21sign/image/pc/dianzan.png" alt="" />
              <img v-if="sortId == 1" src="https://fview.5kjs.com/activity/21sign/image/pc/pinglun.png" alt="" />
              <img v-if="sortId == 2" src="https://fview.5kjs.com/activity/21sign/image/pc/daka.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "topSearch",
  props: {
    camp_id: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      // 排行榜数据
      list: [],
      // 排序顺序
      sortId: 0,
      sortArr: ["praised", "remark", "sign"], //praised:点赞(默认)  remark:评论  sign:打卡
    };
  },
  computed: {
    ...mapState(["token", "agency_id"]),
  },
  methods: {
    // 请求当前排行榜数据
    getRankingList(mytype) {
      let type = "praised";
      if (mytype) {
        type = mytype;
      }
      this.$axios
        .get("/getRankingList", {
          params: {
            // token: this.token,
            agency_id: this.agency_id,
            camp_id: this.camp_id,
            type: type,
          },
        })
        .then((doc) => {
          this.list = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    sortId(newVal) {
      this.getRankingList(this.sortArr[newVal]);
    },
  },
  mounted() {
    this.getRankingList();
  },
};
</script> 

<style lang="less" scoped>
// 排行榜部分
.topSrarch {
  width: 18.75rem;
  background-color: #ffffff;
  //排行榜上部标题部分
  .topSrarch_top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3.125rem;
    width: 100%;
    border-bottom: 0.0625rem solid #f1f1f1;
    .topSrarch_top_content {
      padding: 0 0.9375rem 0 0.9375rem;
      width: 100%;
      display: flex;
      flex-direction: row;
      //   align-items: center;
      justify-content: space-between;
      .topSrarch_top_text {
        padding: 0.3125rem 0.6875rem;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #3d3d3d;
        line-height: 2.3125rem;
        #sort {
          padding: 0.3125rem 0.6875rem;
          border: none;
          outline: none;
          background: #f7f7f7;
          border-radius: 0.125rem;
        }
      }
    }
  }
  //   排行榜下部内容部分
  .topSrarch_bottom {
    padding: 0 0.75rem 0 1.25rem;
    max-height: 28.875rem;
    overflow: hidden;
    .topSrarch_bottom_item_box {
      display: flex;
      //   justify-content: center;
      height: 2.75rem;
      border-bottom: 0.0625rem solid #f1f1f1;
      //   排行榜榜单部分
      .topSrarch_bottom_item {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: auto;
        // 排行榜左侧部分
        .topSrarch_bottom_item_left {
          display: flex;
          flex-direction: row;
          align-items: center;
          .NO_style {
            width: 0.9375rem;
            font-size: 0.875rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ff6600;
            text-align: center;
          }
          .NO_name {
            margin-left: 1rem;
            font-size: 0.875rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #5e5e5e;
          }
          .hot {
            margin-left: 0.8125rem;
            width: 1rem;
            height: 1rem;
            background: #ff9d1a;
            border-radius: 0.125rem;
            font-size: 0.75rem;
            font-family: " Microsoft YaHei";
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 1rem;
          }
        }
        .topSrarch_bottom_item_right {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: .75rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #858585;
          .Number {
            margin-right: 0.375rem;
          }
          .iconImg_box {
            width: 1.125rem;
            height: 1.125rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
    .topSrarch_bottom_item_box:last-child {
      border-bottom: none;
    }
  }
}
</style>